
import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";
import CircularProgress from "@/plugins/circular-progress/circular-progress.vue";

export default defineComponent ({
    name: "DataPolicy",
    inheritAttrs: false,
    components: {
		CircularProgress
	},
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        content: {
            type: String,
            required: true
        }
    },
    setup() {
        const portal = usePortalStore()
        return {
            portal
        };
    }
});